<template>
  <div
    class="group relative bg-white dark:bg-dark-surface rounded-2xl p-8 shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 dark:border-gray-800 hover:border-accent/20 dark:hover:border-accent/30 will-change-transform"
  >
    <!-- Icon Container -->
    <div
      class="w-16 h-16 bg-gradient-to-br from-accent/10 to-accent/5 dark:from-accent/20 dark:to-accent/10 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300"
    >
      <component
        :is="icon"
        :size="32"
        class="text-accent dark:text-accent-300 group-hover:rotate-12 transition-transform duration-300"
      />
    </div>

    <!-- Content -->
    <h3 class="text-xl font-display font-bold text-gray-900 dark:text-white mb-3">
      {{ title }}
    </h3>

    <p class="text-gray-600 dark:text-gray-400 leading-relaxed">
      {{ description }}
    </p>

    <!-- Decorative Element -->
    <div
      class="absolute top-4 right-4 w-20 h-20 bg-gradient-to-br from-primary/5 to-accent/5 dark:from-primary/10 dark:to-accent/10 rounded-full blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"
    ></div>
  </div>
</template>

<script setup>
defineProps({
  icon: {
    type: Object,
    required: true
  },
  title: {
    type: String,
    required: true
  },
  description: {
    type: String,
    required: true
  }
});
</script>
